$(document).ready(function() {
  if (document.querySelector('#remove_image') !== null) {
    document.querySelector('#remove_image').addEventListener('ajax:success', e => {
      var parent = document.getElementById('image_box');
      var animal_image = document.getElementById('animal_image');
      parent.removeChild(animal_image);
    })
  }

  var checkboxQuarantine = document.getElementById('animal_spec_ins_quarantine');
  if (checkboxQuarantine) {
    checkboxQuarantine.onload = setQuarantineVisibility();
    checkboxQuarantine.addEventListener('change', setQuarantineVisibility);  
  }

  var checkboxAgeOther = document.getElementById('animal_age_other');
  if (checkboxAgeOther) {
    checkboxAgeOther.onload = setAgeOtherVisibility();
    checkboxAgeOther.addEventListener('change', setAgeOtherVisibility);  
  }

  $(".single-select").on('change', function() {
    $('input[name="' + this.name + '"]').not(this).prop('checked', false);
  });

  $(".animal-age-select").on('change', setAgeOtherVisibility); 

  // Cascading dropdowns for Animal Type and Breed Species (Form V2)
  initializeAnimalTypeDropdowns();

});

function setQuarantineVisibility() {
  var checkbox = document.getElementById('animal_spec_ins_quarantine');
  var details_div = document.getElementById('quarantine_detailed');
  if (checkbox.checked) {
    details_div.classList.remove('d-none');
    details_div.classList.add('d-block');
  } else {
    details_div.classList.remove('d-block');
    details_div.classList.add('d-none');
  }
}

function setAgeOtherVisibility() {
  var checkbox_other = document.getElementById('animal_age_other');
  var age_other = document.getElementById('age_other_section');

  if (checkbox_other.checked) {
    age_other.classList.remove('d-none');
    age_other.classList.add('d-block');
  } else {
    age_other.classList.remove('d-block');
    age_other.classList.add('d-none');
    document.getElementById('animal_age_other_text').value = "";
  }
}

function initializeAnimalTypeDropdowns() {
  var animalTypeSelect = document.getElementById('animal_type_select');
  var breedSpeciesSelect = document.getElementById('breed_species_select');
  
  if (!animalTypeSelect || !breedSpeciesSelect) {
    return; // Not on the new form, exit
  }

  // Check if breeds data is available globally
  if (typeof window.animalBreedsData === 'undefined') {
    console.error('Animal breeds data not found');
    return;
  }

  var breedsData = window.animalBreedsData;
  
  // Store the current breed species value (for edit forms)
  var currentBreedSpecies = breedSpeciesSelect.value || '';

  // Function to populate breed species dropdown based on animal type
  function populateBreedSpecies(animalType, selectedBreed) {
    // Clear existing options except the first one
    breedSpeciesSelect.innerHTML = '<option value="">Select Breed/Species</option>';
    
    if (animalType && breedsData[animalType]) {
      var breeds = breedsData[animalType];
      breeds.forEach(function(breed) {
        var option = document.createElement('option');
        option.value = breed;
        option.textContent = breed;
        if (breed === selectedBreed) {
          option.selected = true;
        }
        breedSpeciesSelect.appendChild(option);
      });
      breedSpeciesSelect.disabled = false;
    } else {
      breedSpeciesSelect.innerHTML = '<option value="">Select Type First</option>';
      breedSpeciesSelect.disabled = true;
    }
  }

  // Listen for changes on animal type dropdown
  animalTypeSelect.addEventListener('change', function() {
    populateBreedSpecies(this.value, '');
  });

  // Initialize on page load if animal type is already selected
  if (animalTypeSelect.value) {
    populateBreedSpecies(animalTypeSelect.value, currentBreedSpecies);
  }
}
